import { Timestamp } from '@bufbuild/protobuf';
import {
  ContentAttempt,
  TaskEnum,
} from '@protos/learning_management/lms.db_pb';
import { NavigateFunction } from 'react-router-dom';
import { FeatureGateName, isFeatureGateEnabled } from '@geneo2-web/shared-ui';
import { setHomeworkEndPath } from '../pages/Homework/reducer/homework.slice';
import { AppDispatch } from '../reduxStore/store';
import {
  FA_COMPLETED,
  FA_START_COVER,
  HOMEWORK_COMPLETED,
  HOMEWORK_START_COVER,
  LEARNING_HOMEWORK,
} from '../routeHandling/RoutesNomenclature';

export const onHomeworkCardClick = async (
  dispatch: AppDispatch,
  navigate: NavigateFunction,
  homeworkId: bigint | undefined,
  studentId: bigint | undefined,
  homeworkStatus: 'active' | 'ended' = 'active',
  pathName?: string,
  taskType?: TaskEnum,
  isMultiSubjectAssessmentFlow?: boolean,
  resourceIds?: string[]
) => {
  // Learning Homework (demo): a teacher-custom homework with assigned resources.
  // Not a hook, so this reads the school synced by ServiceClientsProvider.
  if (
    resourceIds?.length &&
    isFeatureGateEnabled(FeatureGateName.learningHomeworkEnabled)
  ) {
    if (pathName) {
      dispatch(setHomeworkEndPath(pathName));
    }
    navigate(`${LEARNING_HOMEWORK}?assessmentId=${homeworkId}`);
    return;
  }
  if (homeworkStatus === 'active') {
    if (pathName) {
      dispatch(setHomeworkEndPath(pathName));
    }
    if (
      isMultiSubjectAssessmentFlow ||
      taskType === TaskEnum.TASK_MULTI_SUBJECT_FORMATIVE_ASSESSMENT_CUSTOM || //multi subject FA
      taskType === TaskEnum.TASK_MULTI_SUBJECT_ASSESSMENT_AUTOMATED
    ) {
      navigate(`${FA_START_COVER}?assessmentId=${homeworkId}`);
    } else {
      navigate(`${HOMEWORK_START_COVER}?assessmentId=${homeworkId}`);
    }
  } else {
    console.log(taskType, 'task type');
    if (
      taskType === TaskEnum.TASK_MULTI_SUBJECT_FORMATIVE_ASSESSMENT_CUSTOM || //multi subject FA
      taskType === TaskEnum.TASK_MULTI_SUBJECT_ASSESSMENT_AUTOMATED
    ) {
      navigate(`${FA_COMPLETED}?assessmentId=${homeworkId}`);
    } else {
      navigate(`${HOMEWORK_COMPLETED}?assessmentId=${homeworkId}`);
    }
  }
  // try {
  //   const homeworkContent = await LmsHomeworkCommonAPIServiceV1ClientWithStatusCodeHandler.fetchHomeworkContent({
  //     personId: studentId,
  //     personType: ProfileRolesEnum.PROFILE_ROLE_STUDENT,
  //     homeworkId: homeworkId
  //   })
  //   const homeworkStudentResponse = await LmsHomewokStudentAPIServiceV1Client.fetchStudentHWResponse({
  //     studentId: studentId,
  //     homeworkId: homeworkId
  //   })
  //   dispatch(setActiveHomeworkId(homeworkId));
  //   dispatch(setActiveHomeworkContent(homeworkContent.data));
  //   dispatch(setActiveHomeworkStudentResponse(homeworkStudentResponse.data));
  //   if (homeworkStatus === 'active') {
  //     navigate(`${HOMEWORK_START_COVER}/${homeworkId}`);
  //   } else {
  //     navigate(`${HOMEWORK_COMPLETED}/${homeworkId}`);
  //   }
  // } catch (err) {
  //   dispatch(setActiveHomeworkId(undefined));
  //   dispatch(setActiveHomeworkContent(undefined));
  //   dispatch(setActiveHomeworkStudentResponse(undefined));
  // }
};

// export const getLastValidAttemptedResponse = (attempts?: ContentAttempt[]) => {
//   if (!attempts) {
//     return undefined;
//   }
//   const sortedAttempts = [...attempts].sort((a, b) => {
//     const aTime = new Timestamp(a.endTime)?.toDate().getTime() ?? 0;
//     const bTime = new Timestamp(b.endTime)?.toDate().getTime() ?? 0;
//     return bTime - aTime;
//   });
//   // return attempts[0];

//   // Find the most recent attempt with a valid answer
//   const latestValidAttempt = sortedAttempts.find(
//     (attempt) => attempt.answer && attempt.answer.length > 0
//   );

//   return latestValidAttempt;
// };
